import React from 'react';
import { StarRating } from './ui/StarRating';
interface CustomerReviewProps {
  name: string;
  text: string;
  image?: string;
}
export function CustomerReview({
  name,
  text,
  image
}: CustomerReviewProps) {
  return <div className="border-t border-gray-200 py-2 first:border-t-0" data-id="element-13">
      <StarRating size={18} className="mb-2" data-id="element-14" />
      <p className="text-base md:text-[19px] text-gray-600 italic mb-3 leading-6" data-id="element-15">
        "{text}"
      </p>
      <div className="flex items-center gap-2" data-id="element-16">
        {image && <img src={image} alt={name} className="w-8 h-8 rounded-full object-cover border border-gray-200" data-id="element-17" />}
        <span className="text-xs font-bold text-gray-900" data-id="element-18">{name}</span>
      </div>
    </div>;
}